import type { IToggleBranchCreditParams } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import type { IDistributorsState } from '../../types';

export const toggleBranchCredit = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/toggleBranchCredit`,
  async (params: IToggleBranchCreditParams, { rejectWithValue }) => {
    const { credit } = params;
    const [enabledCredit] = credit.enabled;

    try {
      await apiService.branches.toggleBranchCredit(params);
      const message = enabledCredit?.status
        ? 'Los créditos fueron habilitados correctamente para esta sucursal.'
        : 'La sucursal ya no cuenta con créditos activos.';

      notificationService.global.success(message);
    } catch (error) {
      notificationService.global.error(
        `Error al ${enabledCredit?.status ? 'habilitar' : 'deshabilitar'} los créditos.`,
      );

      return rejectWithValue(error);
    }
  },
);

export const toggleBranchCreditReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(toggleBranchCredit.pending, state => {
      state.branchesList.form.loading = true;
      state.branchesList.form.success = false;
      state.branchesList.form.errors = {};
    })
    .addCase(toggleBranchCredit.rejected, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = false;
    })
    .addCase(toggleBranchCredit.fulfilled, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = true;
      state.branchesList.form.errors = {};
    });
